export const FETCH_USER_FAILED: 'FETCH_USER_FAILED' = 'FETCH_USER_FAILED';
export const FETCH_USER_SUCCESS: 'FETCH_USER_SUCCESS' = 'FETCH_USER_SUCCESS';
export const FETCH_USER_LOADING: 'FETCH_USER_LOADING' = 'FETCH_USER_LOADING';
export const RESET_ERROR_STATUS: 'RESET_ERROR_STATUS' = 'RESET_ERROR_STATUS';
export const UPDATE_USER: 'UPDATE_USER' = 'UPDATE_USER';
export const CLEAR_USER: 'CLEAR_USER' = 'CLEAR_USER';
